import Cctv from '@/assets/smartcity/cctv-intro.svg';
import Dispatch from '@/assets/smartcity/dispatch-intro.svg';
import Health from '@/assets/smartcity/health-intro.svg';
import Notif from '@/assets/smartcity/notif-intro.svg';
import Record from '@/assets/smartcity/record-intro.svg';
import Update from '@/assets/smartcity/update-intro.svg';

export const DATA_FEATURES = [
  {
    id: 1,
    img: Dispatch,
    title: 'Dispatch',
  },
  {
    id: 2,
    img: Update,
    title: 'Update',
  },
  {
    id: 3,
    img: Record,
    title: 'Record',
  },
  {
    id: 4,
    img: Cctv,
    title: 'CCTV',
  },
  {
    id: 5,
    img: Notif,
    title: 'Notification',
  },
  {
    id: 6,
    img: Health,
    title: 'Health',
  },
] as const;
